module.exports = __webpack_public_path__ + "fonts/SFProText-Semibold.211b9d52.woff2";